export const getEnvVariables = (): any => {
    return {
        ...process.env
    }
}